import { SkillsPage } from "@/components/Skills/SkillsPage";

export function Skills() {
  return <SkillsPage />;
}
